module.exports = __webpack_public_path__ + "static/img/single_good3.7fbf1f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/goods/single_good3.png
// module id = qVwZ
// module chunks = 1